var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekButton, PeekDialog, PeekDialogActions, PeekDialogContent, PeekStack, } from "@piiqtechnologies/ui-components";
import { useError, useLoader, useNotification, SpaceType, useSpaceToken, useAnalytics } from "@piiqtechnologies/ui-lib";
import { copyToClipboard, getSpaceUrl } from "@utils";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { getSpaceShareLinkFormFields, SpaceShareLinkFormInitialValues } from "./SpaceShareLinkFormConfig";
var ShareLinkAction;
(function (ShareLinkAction) {
    ShareLinkAction[ShareLinkAction["COPY"] = 0] = "COPY";
    ShareLinkAction[ShareLinkAction["PREVIEW"] = 1] = "PREVIEW";
})(ShareLinkAction || (ShareLinkAction = {}));
export const SpaceShareLinkDialog = ({ spaceId, open, onClose, spaceType, communityId }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setNotification } = useNotification();
    const analytics = useAnalytics();
    const [generateSpaceToken, isGeneratingToken, tokenError] = useSpaceToken();
    useEffect(() => {
        setLoader(isGeneratingToken);
        return () => setLoader(false);
    }, [isGeneratingToken]);
    useEffect(() => {
        if (tokenError) {
            setError(tokenError === null || tokenError === void 0 ? void 0 : tokenError.message);
        }
    }, [tokenError]);
    const onGenerateLink = (_a, validateForm_1, action_1) => __awaiter(void 0, [_a, validateForm_1, action_1], void 0, function* ({ isTracked, prospect, hideAddress }, validateForm, action) {
        const errors = yield validateForm();
        if (!Object.keys(errors).length) {
            const token = yield generateSpaceToken({ spaceId });
            if (token) {
                const spaceUrl = getSpaceUrl(Object.assign(Object.assign({ token }, (isTracked && { pid: prospect._id })), ((spaceType !== SpaceType.Amenity && { showListingDetails: (hideAddress && "false") || "true" }) || {
                    is_amenity: "true",
                })));
                if (action === ShareLinkAction.PREVIEW) {
                    window.open(spaceUrl);
                    analytics.track("Virtual Tour Link Previewed");
                    onClose();
                    return;
                }
                yield copyToClipboard(spaceUrl.toString());
                analytics.track("Virtual Tour Link Copied");
                setNotification(intl.formatMessage(messages.spaceShareLinkCopySuccess));
                onClose();
                return;
            }
            setError(intl.formatMessage(messages.spaceShareLinkError));
            onClose();
        }
    });
    const validateSpaceShareLink = (values) => {
        var _a;
        const errors = {};
        if (values.isTracked && !((_a = values.prospect) === null || _a === void 0 ? void 0 : _a.email)) {
            errors.prospect = intl.formatMessage(messages.spaceShareLinkProspectError);
        }
        return errors;
    };
    return (React.createElement(PeekDialog, { maxWidth: "xs", fullWidth: true, hasCloseIcon: true, title: intl.formatMessage(messages.spaceShareLinkTitle), open: open, onClose: onClose },
        React.createElement(Formik, { initialValues: SpaceShareLinkFormInitialValues, validate: validateSpaceShareLink, onSubmit: () => {
                console.log("empty handler");
            } }, ({ values, validateForm, setTouched }) => (React.createElement(Form, null,
            React.createElement(PeekDialogContent, null,
                React.createElement(MultiColumnFormFields, { alignItems: "center", fields: getSpaceShareLinkFormFields(communityId) })),
            React.createElement(PeekDialogActions, null,
                React.createElement(PeekStack, { spacing: 1, width: "100%" },
                    React.createElement(PeekButton, { fullWidth: true, size: "large", onClick: () => {
                            setTouched({ prospect: true });
                            onGenerateLink(values, validateForm, ShareLinkAction.PREVIEW);
                        }, color: "primary", variant: "outlined" }, intl.formatMessage(messages.spaceShareLinkPreviewButton)),
                    React.createElement(PeekButton, { fullWidth: true, size: "large", onClick: () => {
                            setTouched({ prospect: true });
                            onGenerateLink(values, validateForm, ShareLinkAction.COPY);
                        }, color: "primary", variant: "contained" }, intl.formatMessage(messages.spaceShareLinkCopyButton)))))))));
};
export default SpaceShareLinkDialog;
